import * as types from "./types";
import { combineReducers } from "redux";
import cloneDeep from "lodash/cloneDeep";

function dataSaved(state = { status: false, message: "" }, action) {
  switch (action.type) {
    case types.DATA_SAVED:
      return action.payload;
    case types.RESET_DATA_SAVED:
      return { status: false, message: "" };
    default:
      return state;
  }
}

function searchDataAlumnos(state = [], { type, payload }) {
  switch (type) {
    case types.FETCH_ALUMNOS:
      return [...cloneDeep(state), cloneDeep(payload)];

    case types.RESET:
    case types.RESET_SEARCH_ALUMNOS:
      return [];

    default:
      return state;
  }
}
function searchDataColegios(state = [], { type, payload }) {
  switch (type) {
    case types.FETCH_COLEGIOS:
      let data = cloneDeep(state);
      data.push(payload);
      return data;

    case types.RESET:
      return [];

    default:
      return state;
  }
}
function searchDataActividades(state = [], { type, payload }) {
  switch (type) {
    case types.FETCH_ACTIVIDADES:
      let data = cloneDeep(state);
      data.push(payload);
      return data;

    case types.RESET:
    case types.RESET_SEARCH_ACTIVIDADES:
      return [];

    default:
      return state;
  }
}

function searchByNombre(state = [], action) {
  switch (action.type) {
    case types.FETCH_SEARCH_ESCUELA_NOMBRES:
      return action.payload;
    case types.RESET_SEARCH_ESCUELAS:
      return [];
    default:
      return state;
  }
}
function searchByResguardo(state = [], action) {
  switch (action.type) {
    case types.FETCH_SEARCH_ESCUELA_RESGUARDO:
      return action.payload;
    case types.RESET_SEARCH_ESCUELAS:
      return [];
    default:
      return state;
  }
}
function searchByColegio(state = [], action) {
  switch (action.type) {
    case types.FETCH_SEARCH_ESCUELA_COLEGIOS:
      return action.payload;
    case types.RESET_SEARCH_ESCUELAS:
      return [];
    default:
      return state;
  }
}

const reducer = combineReducers({
  dataSaved,
  searchDataAlumnos,
  searchDataColegios,
  searchDataActividades,
  searchByNombre,
  searchByResguardo,
  searchByColegio
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/busquedas/reducers.js